import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

import Navbar from "./components/Navbar";
import Chatbot from "./components/Chatbot";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Portfolio from "./pages/Portfolio";
import Contact from "./pages/Contact";
import Team from "./pages/Team";
import Testimonials from "./pages/Testimonials";
import VideoHub from "./pages/VideoHub";
import Order from "./pages/Order";

// Digital Products
import DigitalProducts from "./pages/DigitalProducts";
import ChineseScholarship from "./pages/ChineseScholarship";

import "./styles/global.css";

function App() {
  return (
    <div className="app-container">

      <Router>

        {/* Navigation */}
        <Navbar />

        {/* Chatbot */}
        <Chatbot />

        <div className="page-content">

          <Routes>

            {/* =========================
                HOME
            ========================== */}

            <Route
              path="/"
              element={<Home />}
            />


            {/* =========================
                ABOUT
            ========================== */}

            <Route
              path="/about"
              element={<About />}
            />


            {/* =========================
                SERVICES
            ========================== */}

            <Route
              path="/services"
              element={<Services />}
            />


            {/* =========================
                PORTFOLIO
            ========================== */}

            <Route
              path="/portfolio"
              element={<Portfolio />}
            />


            {/* =========================
                CONTACT
            ========================== */}

            <Route
              path="/contact"
              element={<Contact />}
            />


            {/* =========================
                TEAM
            ========================== */}

            <Route
              path="/team"
              element={<Team />}
            />


            {/* =========================
                TESTIMONIALS
            ========================== */}

            <Route
              path="/testimonials"
              element={<Testimonials />}
            />


            {/* =========================
                VIDEO HUB
                Existing route kept
            ========================== */}

            <Route
              path="/videohub"
              element={<VideoHub />}
            />


            {/* =========================
                ORDER PAGE
            ========================== */}

            <Route
              path="/order"
              element={<Order />}
            />


            {/* =========================
                DIGITAL PRODUCTS
            ========================== */}

            <Route
              path="/digital-products"
              element={<DigitalProducts />}
            />


            {/* =========================
                CHINESE SCHOLARSHIP
                FULL GUIDE / PAYMENT PAGE
            ========================== */}

            <Route
              path="/digital-products/chinese-scholarship"
              element={<ChineseScholarship />}
            />

          </Routes>

        </div>

        {/* Footer */}
        <Footer />

      </Router>

    </div>
  );
}

export default App;